import { boatTypeConstants, globalConstants } from "../../constants";

const initialState = {
  boatTypeData: [],
  boatTypeUnOfficialData: [],
  boatClassesData: {},
  boatClassesDataById: {},
  genderBoatClassData: {},
};

const BoatTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case boatTypeConstants.BOAT_TYPE_DATA + globalConstants.SUCCESS:
      return {
        ...state,
        boatTypeData: action.data,
      };
    case boatTypeConstants.BOAT_TYPE_UNOFFICIAL_DATA + globalConstants.SUCCESS:
      return {
        ...state,
        boatTypeUnOfficialData: action.data,
      };
    case boatTypeConstants.BOAT_CLASS_DATA + globalConstants.SUCCESS:
      return {
        ...state,
        boatClassesData: action.data,
      };
    case boatTypeConstants.BOAT_CLASS_DATA_BY_ID + globalConstants.SUCCESS:
      return {
        ...state,
        boatClassesDataById: action.data,
      };
    case boatTypeConstants.GET_ALL_GENDER_BOAT_CLASS_DATA +
      globalConstants.SUCCESS:
      return {
        ...state,
        genderBoatClassData: action.data,
      };
    default:
      return state;
  }
};

export default BoatTypeReducer;
